export const US_PRESETS = {
  all: {
    label: "All US",
    symbols: ["AAPL", "MSFT", "NVDA", "AMZN", "GOOGL", "META", "TSLA", "BRK-B", "JPM", "XOM"],
  },
  tech: {
    label: "Tech & AI",
    symbols: ["NVDA", "MSFT", "AAPL", "GOOGL", "META", "AVGO", "AMD"],
  },
  value: {
    label: "Value & Low P/E",
    symbols: ["BRK-B", "JPM", "XOM", "CVX", "UNH", "PG"],
  },
  macro: {
    label: "Macro & Commodities",
    symbols: ["GLD", "USO", "IBIT", "SPY", "TLT"],
  },
};

export const STOCK_NAMES = {
  "7203.T": "Toyota",
  "6758.T": "Sony",
  "8306.T": "MUFG",
  "9984.T": "SoftBank",
  "8035.T": "Tokyo Electron",
  "6861.T": "Keyence",
  "2222.SR": "Aramco",
  "1120.SR": "Al Rajhi",
  "1180.SR": "SNB",
  "2010.SR": "SABIC",
  "7010.SR": "stc",
  "1211.SR": "Maaden",
};

export function stockDisplayName(symbol) {
  const text = String(symbol || "").split("/")[0].replace(/=X$/i, "");
  return STOCK_NAMES[text] || STOCK_NAMES[text.toUpperCase()] || text;
}

export function stockTickerCode(symbol) {
  const text = String(symbol || "").split("/")[0].replace(/=X$/i, "");
  const key = STOCK_NAMES[text] ? text : STOCK_NAMES[text.toUpperCase()] ? text.toUpperCase() : "";
  return key ? key.split(".")[0] : "";
}

export const STOCK_BOARDS = {
  us: {
    label: "US",
    symbols: US_PRESETS.all.symbols,
  },
  indonesia: {
    label: "Indonesia",
    symbols: ["BBCA.JK", "BBRI.JK", "BMRI.JK", "TLKM.JK", "ASII.JK"],
  },
  iran: {
    label: "Iran",
    symbols: ["فملی", "فولاد", "شپنا", "خودرو", "وبملت"],
  },
  australia: {
    label: "Australia",
    symbols: ["BHP.AX", "CBA.AX", "CSL.AX", "NAB.AX", "WBC.AX"],
  },
  japan: {
    label: "Japan",
    symbols: ["7203.T", "6758.T", "8306.T", "9984.T", "8035.T", "6861.T"],
  },
  ksa: {
    label: "KSA",
    symbols: ["2222.SR", "1120.SR", "1180.SR", "2010.SR", "7010.SR", "1211.SR"],
  },
};

export function isStockBoard(market) {
  return Boolean(STOCK_BOARDS[market]);
}

export function stockBoardLabel(market) {
  return STOCK_BOARDS[market]?.label || "";
}

export function boardSymbols(market, extra = [], preset = "all") {
  const seen = new Set();
  const symbols = [];
  const base = market === "us"
    ? (US_PRESETS[preset]?.symbols || US_PRESETS.all.symbols)
    : (STOCK_BOARDS[market]?.symbols || []);
  [...base, ...(extra || [])].forEach((symbol) => {
    const name = String(symbol || "").trim();
    if (!name || seen.has(name)) return;
    seen.add(name);
    symbols.push(name);
  });
  return symbols;
}

export function stockBoardCards(market, extra = [], preset = "all") {
  return boardSymbols(market, extra, preset).map((symbol) => ({
    SYMBOL_NAME: symbol,
    TRADE_TYPE: "",
    stockBoard: true,
  }));
}

export function quoteCards(symbols) {
  return (symbols || []).map((symbol) => ({
    SYMBOL_NAME: symbol,
    TRADE_TYPE: "",
    stockBoard: true,
  }));
}

export function stockPivotTargets(market, extra = [], preset = "all") {
  return stockBoardCards(market, extra, preset).map((row) => ({
    symbol: row.SYMBOL_NAME,
    exchange: "yahoo",
    timeframe: "1d",
    stock: true,
  }));
}

function dailySuggestion(suggestions, coin) {
  const name = String(coin || "").split("/")[0].toUpperCase();
  return (suggestions || []).find((item) => {
    const symbol = String(item?.symbol || "").split("/")[0].toUpperCase();
    return symbol === name && String(item?.timeframe || "") === "1d";
  });
}

export function sortStockCards(rows, suggestions) {
  return (rows || [])
    .map((row, index) => {
      const live = dailySuggestion(suggestions, row?.SYMBOL_NAME);
      const side = !live || live.miss || live.price == null
        ? ""
        : String(live.prediction || "").split("/")[0];
      const rank = side === "Buy" ? 0 : side === "Sell" ? 1 : 2;
      return { row, index, rank };
    })
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map((item) => item.row);
}
